import { ActionsUnion, createAction } from 'spw-redux/types';
import { IChildWorksheetSpaceType } from 'spw-redux/modules/calculators/types';
import { IProjectSpaceType } from 'spw-redux/modules/space_types/types';
import {
  IProjectSpaceTypeCategory,
  IProjectSpaceTypeSubcategory,
} from 'spw-redux/modules/projects/types';
import { PlainProgramScenario } from '../../../models/Scenario';
import WorksheetRow from '../../../models/WorksheetRow';
import { PlainWorksheet } from '../../../models/Worksheet';

export const SET_IS_SPACE_TYPE_DELETABLE =
  'worksheet/SET_IS_SPACE_TYPE_DELETABLE';
export const FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_CATEGORY =
  'worksheet/FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_CATEGORY';
export const FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_CATEGORY_SUCCESS =
  'worksheet/FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_CATEGORY_SUCCESS';
export const FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_ROW =
  'worksheet/FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_ROW';
export const FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_ROW_SUCCESS =
  'worksheet/FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_ROW_SUCCESS';
export const SET_REMOVE_SPACE_TYPE_DIALOG_STATUS =
  'worksheet/SET_REMOVE_SPACE_TYPE_DIALOG_STATUS';
export const SET_SELECTED_WORKSHEET_ROW =
  'worksheet/SET_SELECTED_WORKSHEET_ROW';
export const SET_SELECTED_SPACE_TYPE_CATEGORY =
  'worksheet/SET_SELECTED_SPACE_TYPE_CATEGORY';
export const SET_SELECTED_SPACE_TYPE = 'worksheet/SET_SELECTED_ROW_SPACE_TYPE';
export const SET_SELECTED_CHILD_SPACE_TYPE =
  'worksheet/SET_SELECTED_CHILD_SPACE_TYPE';
export const DELETE_SPACE_TYPE_FROM_PROJECT =
  'worksheet/DELETE_SPACE_TYPE_FROM_PROJECT';
export const DELETE_CHILD_SPACE_TYPE_FROM_PROJECT =
  'worksheet/DELETE_CHILD_SPACE_TYPE_FROM_PROJECT';
export const DELETE_CUSTOM_SUBCATEGORY_SPACE_TYPES =
  'worksheet/DELETE_CUSTOM_SUBCATEGORY_SPACE_TYPES';
export const DELETE_CATEGORY_ROWS_FROM_PROJECT =
  'worksheet/DELETE_CATEGORY_ROWS_FROM_PROJECT';
export const DELETE_SPACE_TYPE_ROWS_FROM_PROJECT =
  'worksheet/DELETE_SPACE_TYPE_ROWS_FROM_PROJECT';
export const DELETE_CHILD_WORKSHEET_SPACE_ROWS_FROM_PROJECT =
  'worksheet/DELETE_CHILD_WORKSHEET_SPACE_ROWS_FROM_PROJECT';
export const UPDATE_CHILD_SPACE_TYPE_POSITION =
  'worksheet/UPDATE_CHILD_SPACE_TYPE_POSITION';
export const DELETE_WORKSHEET_ROW = 'worksheet/DELETE_WORKSHEET_ROW';
export const ADD_ROWS_TO_PROJECT_WORKSHEETS =
  'worksheet/ADD_ROWS_TO_PROJECT_WORKSHEETS';
export const UPDATE_WORKSHEET_CATEGORY = 'worksheet/UPDATE_WORKSHEET_CATEGORY';

export const SET_WORKSHEET_DECIMALS_ARE_ENABLED =
  'worksheet/SET_WORKSHEET_DECIMALS_ARE_ENABLED';

export const setIsSpaceTypeDeletable = (canDeleteSpaceType: boolean) =>
  createAction(SET_IS_SPACE_TYPE_DELETABLE, { canDeleteSpaceType });

export const fetchScenariosAssociatedWithSelectedCategory = (
  spaceTypeCategoryId: number
) =>
  createAction(FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_CATEGORY, {
    spaceTypeCategoryId,
  });

export const fetchScenariosAssociatedWithSelectedCategorySuccess = (
  scenariosUsingSpaceTypeOrCategory: PlainProgramScenario[],
  worksheetsUsingSpaceTypeOrCategory: {
    byId: {
      [key: string]: PlainWorksheet;
    };
  }
) =>
  createAction(FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_CATEGORY_SUCCESS, {
    scenariosUsingSpaceTypeOrCategory,
    worksheetsUsingSpaceTypeOrCategory,
  });

export const fetchScenariosAssociatedWithSelectedRow = (
  projectId: number,
  spaceTypeId: number,
  isChild: boolean
) =>
  createAction(FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_ROW, {
    projectId,
    spaceTypeId,
    isChild,
  });

export const fetchScenariosAssociatedWithSelectedRowSuccess = (
  scenariosUsingSpaceTypeOrCategory: PlainProgramScenario[],
  worksheetsUsingSpaceTypeOrCategory: {
    byId: {
      [key: string]: PlainWorksheet;
    };
  }
) =>
  createAction(FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_ROW_SUCCESS, {
    scenariosUsingSpaceTypeOrCategory,
    worksheetsUsingSpaceTypeOrCategory,
  });

export const setRemoveSpaceTypeDialogStatus = (
  status: boolean,
  hideAllMode?: boolean
) =>
  createAction(SET_REMOVE_SPACE_TYPE_DIALOG_STATUS, {
    status,
    hideAllMode: !!hideAllMode,
  });

export const setWorksheetDecimalsAreEnabled = (enabled: boolean) =>
  createAction(SET_WORKSHEET_DECIMALS_ARE_ENABLED, enabled);

export const setSelectedWorksheetRow = (row: WorksheetRow) =>
  createAction(SET_SELECTED_WORKSHEET_ROW, { row });

export const setSelectedSpaceTypeCategory = (
  spaceTypeCategory?: IProjectSpaceTypeCategory | IProjectSpaceTypeSubcategory
) => createAction(SET_SELECTED_SPACE_TYPE_CATEGORY, { spaceTypeCategory });

export const setSelectedSpaceType = (spaceType?: IProjectSpaceType) =>
  createAction(SET_SELECTED_SPACE_TYPE, { spaceType });

export const setSelectedChildSpaceType = (
  childSpaceType?: IChildWorksheetSpaceType
) => createAction(SET_SELECTED_CHILD_SPACE_TYPE, { childSpaceType });

export const deleteSpaceTypeFromProject = (projectSpaceTypeId: number) =>
  createAction(DELETE_SPACE_TYPE_FROM_PROJECT, { projectSpaceTypeId });

export const deleteChildSpaceTypeFromProject = (childSpaceTypeId: number) =>
  createAction(DELETE_CHILD_SPACE_TYPE_FROM_PROJECT, { childSpaceTypeId });

export const deleteCustomSubcategorySpaceTypes = (
  projectSpaceTypes: Partial<IProjectSpaceType>[]
) => createAction(DELETE_CUSTOM_SUBCATEGORY_SPACE_TYPES, { projectSpaceTypes });

export const deleteSpaceTypeRowsFromProject = (projectSpaceTypeId: number) =>
  createAction(DELETE_SPACE_TYPE_ROWS_FROM_PROJECT, { projectSpaceTypeId });

export const deleteCategoryRowsFromProject = (spaceTypeCategoryId: number) =>
  createAction(DELETE_CATEGORY_ROWS_FROM_PROJECT, { spaceTypeCategoryId });

export const deleteChildWorksheetSpaceRowsFromProject = (
  childWorksheetSpaceId: number
) =>
  createAction(DELETE_CHILD_WORKSHEET_SPACE_ROWS_FROM_PROJECT, {
    childWorksheetSpaceId,
  });

export const updateChildSpaceTypePosition = (
  childSpaceTypeId: number,
  previousChildSpaceTypeId: number | null,
  nextChildSpaceTypeId: number | null
) =>
  createAction(UPDATE_CHILD_SPACE_TYPE_POSITION, {
    childSpaceTypeId,
    previousChildSpaceTypeId,
    nextChildSpaceTypeId,
  });

export const deleteWorksheetRow = (row: WorksheetRow) =>
  createAction(DELETE_WORKSHEET_ROW, { row });

export const addRowsToProjectWorksheets = ({
  spaceTypeCategoryId,
  projectSpaceTypeId,
  childWorksheetSpaceTypeId,
}: {
  spaceTypeCategoryId?: number;
  projectSpaceTypeId?: number;
  childWorksheetSpaceTypeId?: number;
}) =>
  createAction(ADD_ROWS_TO_PROJECT_WORKSHEETS, {
    spaceTypeCategoryId,
    projectSpaceTypeId,
    childWorksheetSpaceTypeId,
  });

export const updateWorksheetCategory = (
  worksheetId: number,
  categoryId: number,
  visible: boolean,
  parentCategoryId?: number
) =>
  createAction(UPDATE_WORKSHEET_CATEGORY, {
    worksheetId,
    categoryId,
    visible,
    parentCategoryId,
  });

export const actions = {
  setIsSpaceTypeDeletable,
  fetchScenariosAssociatedWithSelectedCategory,
  fetchScenariosAssociatedWithSelectedCategorySuccess,
  fetchScenariosAssociatedWithSelectedRow,
  fetchScenariosAssociatedWithSelectedRowSuccess,
  setRemoveSpaceTypeDialogStatus,
  setSelectedWorksheetRow,
  setSelectedSpaceTypeCategory,
  setSelectedSpaceType,
  setSelectedChildSpaceType,
  deleteSpaceTypeFromProject,
  deleteChildSpaceTypeFromProject,
  deleteCustomSubcategorySpaceTypes,
  deleteSpaceTypeRowsFromProject,
  deleteCategoryRowsFromProject,
  deleteChildWorksheetSpaceRowsFromProject,
  updateChildSpaceTypePosition,
  setWorksheetDecimalsAreEnabled,
  deleteWorksheetRow,
  addRowsToProjectWorksheets,
  updateWorksheetCategory,
};

export type Actions = ActionsUnion<typeof actions>;
